import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setCurrentRoute } from '../../redux/reducers/utils/navReducer';

function KitchenModule() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCurrentRoute('/kitchen/dashboard'));
    navigate('/kitchen/dashboard');
  }, []);

  return null;
}

export default KitchenModule;
